<div class="becorps-container">
  <app-screen-spinner></app-screen-spinner>
  <router-outlet></router-outlet>
</div>
